var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('h2',[_vm._v("Account")]),_c('AccountDetails',{attrs:{"account":_vm.account}}),_c('pre',{directives:[{name:"show",rawName:"v-show",value:(_vm.debugMode),expression:"debugMode"}],staticClass:"debug"},[_vm._v(_vm._s(_vm.account))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }